import { State, Selector, Action, StateContext, Store } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { GetUserDirectory } from './user-directory.action';
import FuzzySearch from 'fuzzy-search';
import { UserDirectoryService, UserDirectoryEntry } from 'app/services/user-directory/user-directory.service';
import { Injectable } from '@angular/core';

export interface UserDirectoryStateModel {
    users: UserDirectoryEntry[];
}

@State<UserDirectoryStateModel>({
    name: 'userDirectory',
    defaults: {
        users: []
    }
})

@Injectable()

export class UserDirectoryState {
    @Selector()
    static search(state: UserDirectoryStateModel) {
        return (term: string) => (new FuzzySearch(state.users, ['fullname', 'email'], {
                caseSensitive: false
            })).search(term) as UserDirectoryEntry[];
    }

    @Selector()
    static users(state: UserDirectoryStateModel): UserDirectoryEntry[] {
        return state.users;
    }

    fetched = false;

    constructor(
        private userDirectoryService: UserDirectoryService,
        private http: ApiHttpClient
    ) { }


    @Action(GetUserDirectory, {
        cancelUncompleted: true
    })
    getUserDirectory({ patchState }: StateContext<UserDirectoryStateModel>, { }:
        GetUserDirectory) {
        if (this.fetched) {
            return;
        }
        this.fetched = true;

        return this.userDirectoryService.getUserDirectoryEntries().pipe(
            tap(results => {
                patchState({ users: results });
            }),
            catchError(err => throwError(() => err))
        );

    }
}
